module.exports = __webpack_public_path__ + "img/symbol_6.3f539115.png";